//================================================================
//  Page: AuditLogs.js 
//================================================================

//  Purpose: AuditLogs Tab

//================================================================

// Libraries

// Contexts

// Components
import PageComponent from '../../../../../Components/PageComponent/PageComponent';
import TabView from '../../../../../Components/TabView/TabView';


export default function AuditLogs() {

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (

    <PageComponent
      header={
        <div className='flex flex-col p-4 gap-1 bg-neutral-100 w-full border-solid border-1 border-neutral-300'>
          <h4 className='flex items-center h-full cursor-default text-[22px]'>
            Audit Logs
          </h4>
          <p className='text-[#424242] font-sans text-[16px] leading-[24px] m-0'></p>
        </div>
      }
      body={
        <TabView
          defaultView={1}
          oneTitle={'Agreements'}
          oneRoute='/settings?tab=auditlogs&view=agreements'
          oneContent={
            <>Audit Logs ~ Agreements</>
          }
          twoTitle={'Applications'}
          twoRoute='/settings?tab=auditlogs&view=applications'
          twoContent={
            <>Audit Logs ~ Applications</>
          }
          threeTitle={'Vendors'}
          threeRoute='/settings?tab=auditlogs&view=vendors'
          threeContent={
            <>Audit Logs ~ Vendors</>
          }
          fourTitle={'IPAM (Subnets)'}
          fourRoute='/settings?tab=auditlogs&view=subnets'
          fourContent={
            <>Audit Logs ~ IPAM (Subnets)</>
          }
        > </TabView>
      }

    ></PageComponent>

  )

}
